<template>
  <footer>
    <div class="container-fluid footer">
      <span>Copyright © 2021 台灣公車 e 點通 All rights reserved.</span>
    </div>
  </footer>
</template>
